import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const ReceivingComplaint = (params) => {
  
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ReceivingComplaint",
    params
  );
};

const getComplaintForScreening = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/ForScreening",
    params
  );
};

const getComplaintForUser = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/ForUser",
    params
  );
};

const getComplaintById = (id) => {
  const params = {
    id
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/GetById",
    params,
  )
}

const addComplaintGroup = (params, userId) => {
  // console.log("url", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/AddComplaintGroup?userId=" + 
  //   userId,
  //   params)

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/AddComplaintGroup?userId=" + 
    userId,
    params
  )
}

const movCompliant = (params) => {
  // console.log("urlMovCompliant", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/RemoveComplaintGroup?userId=" + 
  //   params.userActive,
  //   params)

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/RemoveComplaintGroup?userId=" + 
    params.userActive,
    params
  )
}

const movComplaintGroup = (params) => {
  // console.log("movComplaintGroup", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/RemoveComplaintGroup?userId=" + 
  //   params.userActive,
  //   params)

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/RemoveComplaintGroup?userId=" + 
    params.userActive,
    params
  )
}

const getStatusMenu = (departmentId, complaintGroupId) => {
  const params = {
    departmentId,
    complaintGroupId
  }
  // console.log("Url: getStatusMenu", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetStatusMenu",
  //   params)

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetStatusMenu",
    params,
  ) 
}

const getTracking = (complaintGroupId) => {
  const params = {
    complaintGroupId
  }
  // console.log("Url: getTrackingGroup", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupTracking/GetTracking",
  //   params)

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupTracking/GetTracking",
    params,
  )
}

const getOfficerStatusMenu = (departmentId, complaintGroupId) => {
  const params = {
    departmentId,
    complaintGroupId,
  };
  // console.log("Url: getOfficerStatusMenu", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetOfficerStatusMenu",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetOfficerStatusMenu",
    params
  );
};

const getLawOfficerStatusMenu = (departmentId, complaintGroupId) => {
  const params = {
    departmentId,
    complaintGroupId,
  };
  // console.log("Url: getLawOfficerStatusMenu", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetLawOfficerStatusMenu",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetLawOfficerStatusMenu",
    params
  );
};

const getStatusProcess = (actionType, value) => {
  const params = {
    actionType,
    value
  }
  // console.log("Url: getStatusProcess", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetStatusProcess",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupStatus/GetStatusProcess",
    params
  );
};

const updateComplaintProcess = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/UpdateComplaintProcess",
    params
  );
};

const updateComplaintProcess_No_Doc = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/UpdateComplaintProcess_No_Doc",
    params
  );
};


const getLastedByComplaintGroupId = (id) => {
  const params = {
    id
  }
  // console.log("Url: getLastedByComplaintGroupId", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/GetLastedByComplaintGroupId",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/GetLastedByComplaintGroupId",
    params
  );
}; 

const getQueueLoaderLineByQueueLoderId = (params) => {
  // console.log("Url: getQueueLoaderLineByQueueLoderId", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/GetQueueLoaderLineByQueueLoderId",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/GetQueueLoaderLineByQueueLoderId",
    params
  );
};

const queueLoaderLineResend = (params) => {
  // console.log("Url: queueLoaderLineResend", 
  //   appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/QueueLoaderLineResend",
  //   params
  // )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroupQueue/QueueLoaderLineResend",
    params
  );
};

export {
  getComplaintForScreening,
  getComplaintById,
  getComplaintForUser,
  addComplaintGroup,
  movCompliant,
  movComplaintGroup,

  getStatusMenu,
  getTracking,
  getOfficerStatusMenu,
  getLawOfficerStatusMenu,
  getStatusProcess,
  updateComplaintProcess,
  updateComplaintProcess_No_Doc,
  getLastedByComplaintGroupId,
  getQueueLoaderLineByQueueLoderId,
  queueLoaderLineResend
};
